import React from 'react';
import _ from 'lodash';
import { Dialog, Input, Picker } from '@tencent/spaui';


import PropTypes from 'prop-types';
import { RPCFactory } from '../../../utils/RequestUtil';
import { store } from '../../../store/Store';
import { GlobalStateAction } from '../../../actions/GlobalStateAction';

export default class GroupDetailPresentationalComponent extends React.Component {
  componentDidMount() {
    if (this.props.userGroupId) {
      RPCFactory.employeeManage
        .getGroupById(this.state.userGroupId)
        .done((data) => {
          const employees = [];
          for (let i = 0; i < data.length; i++) {
            employees.push({
              name: data[i].username,
              userId: data[i].userId,
            });
          }
          this.setState({
            employees,
            groupEmployeesNeedConfirm: employees,
          });
        })
        .fail((code, msg) => {
          window.alert(`获取团队信息失败，失败信息：${msg}`);
          this.props.onCancel();
        });
    }
    this.getEmployees();
  }
  constructor(props) {
    super(props);

    this.state = {
      userGroupId: this.props.userGroupId,
      userGroupName: this.props.userGroupName,
      employees: [],
      groupEmployeesNeedConfirm: [],
      employeeList: [],
      searchName: '',
      pageIndex: 1,
      pageSize: 10,
      totalSize: 0,
      showTeamChangeDialog: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onLoad = this.onLoad.bind(this);
    this.getEmployees = this.getEmployees.bind(this);
  }

  getEmployees(isConcat, cb) {
    RPCFactory.employeeManage
      .getEmployees(
        this.state.searchName != '' ? this.state.searchName : undefined,
        undefined,
        undefined,
        undefined,
        this.state.pageSize,
        this.state.pageIndex,
        0,
      )
      .done((data) => {
        let newEmployees = data.entities.map((item) => ({ name: item.name || '未命名', userId: item.userId }));

        if (isConcat) {
          newEmployees = this.state.employeeList.concat(newEmployees);
        }

        this.setState({
          employeeList: newEmployees,
          totalSize: data.size,
        });
      })
      .fail((ret, msg) => {
        window.alert(`查询失败，错误信息：${msg}`);
      });
  }

  handleChange(event, value) {
    this.setState({
      groupEmployeesNeedConfirm: (value || []).map((item) => {
        if (item.name) {
          return item;
        }
        const { employeeList } = this.state;
        for (let i = 0; i < employeeList.length; i++) {
          if (employeeList[i].userId == item) {
            return { name: employeeList[i].name || '未命名', userId: item };
          }
        }
      }),
    });
  }

  handleTeamChangeConfirm = () => {
    this.setState({
        employees: this.state.groupEmployeesNeedConfirm,
        showTeamChangeDialog: false,
      },
      () => this.onConfirm(),
    );
  }
  handleEmployeeTeamChangeClose = () => {
    this.setState({
      groupEmployeesNeedConfirm: this.state.employees,
      showTeamChangeDialog: false,
    });
  }
  onSearchChange(event, value) {
    this.setState({ pageIndex: 1, searchName: value }, () => {
      this.getEmployees(false);
    });
  }

  onLoad() {
    this.setState({ pageIndex: this.state.pageIndex + 1 }, () => {
      if (this.state.pageIndex <= Math.ceil(this.state.totalSize / this.state.pageSize)) {
        this.getEmployees(true);
      } else {
        window.alert('没有更多员工可以加载！');
      }
    });
  }

  updateEmployees(employees) {
    this.setState({ employees: employees || [] });
  }

  onConfirm = (e) => {
    if (this.state.userGroupName == '') {
      window.alert('团队名称不能为空');
      return false;
    }
    const userIds = [];
    for (let i = 0; i < this.state.employees.length; i++) {
      userIds.push(this.state.employees[i].userId);
    }
    store.dispatch({
      type: GlobalStateAction.ADD_EDIT_GROUP,
      payload: {
        groupList: [],
      },
    });
    if (!this.props.userGroupId) {
      // add
      RPCFactory.employeeManage
        .addUserGroup(this.state.userGroupName, userIds)
        .done((data) => {
          this.props.onConfirm();
        })
        .fail((ret, msg) => {
          window.alert(`查询失败，错误信息：${msg}`);
        });
    } else {
      // update
      RPCFactory.employeeManage
        .updateUserGroup(this.props.userGroupId, this.state.userGroupName, userIds)
        .done((data) => {
          this.props.onConfirm();
        })
        .fail((ret, msg) => {
          window.alert(`查询失败，错误信息：${msg}`);
        });
    }
  };

  onCancel = (e) => {
    this.props.onCancel();
  };

  handleGroupNameChange = (e, value) => {
    this.setState({
      userGroupName: value,
    });
  };

  handleConfirmEditGroup = () => {
    if (_.isEqual(this.state.employees.sort(), this.state.groupEmployeesNeedConfirm.sort())) {
      this.onConfirm();
    } else {
      this.setState({ showTeamChangeDialog: true });
    }
  }

  render() {
    const { groupEmployeesNeedConfirm } = this.state;
    return (
      <div>
        <Dialog
          type="normal"
          show={this.props.show}
          backdrop
          onClose={this.onCancel}
          onSubmit={this.handleConfirmEditGroup}
          onCancel={this.onCancel}
          title={this.state.userGroupId != '' ? (this.state.userGroupId == 0 ? '查看团队' : '编辑团队') : '添加团队'}
          className=""
          cancelButton={this.state.userGroupId != '' ? this.state.userGroupId != 0 : true}
          submitButton={this.state.userGroupId != '' ? this.state.userGroupId != 0 : true}
        >
          <div className="">
            <div className="configs">
              <ul className="config-list">
                <li className="config-li">
                  <p className="name">团队名称</p>
                  <div className="form-in">
                    <Input
                      value={this.state.userGroupName}
                      onChange={this.handleGroupNameChange.bind(this)}
                      placeholder="请输入团队名称"
                    />
                  </div>
                </li>
                <li className="config-li">
                  <p className="name">选择队员（一个员工只能隶属于一个团队）</p>
                  <div className="form-in">
                    <Picker
                      selectionTitle="已选择员工"
                      selectionEmptyLabel="请在左侧选择添加员工"
                      className="employee-edit-dialog-picker"
                      data={this.state.employeeList}
                      value={groupEmployeesNeedConfirm}
                      valueKey="userId"
                      onChange={this.handleChange}
                      searchPlaceholder="输入员工姓名进行搜索"
                      onSearchChange={this.onSearchChange}
                      asyncLoading={true}
                      onLoad={this.onLoad}
                      disabled={this.state.userGroupId != '' ? this.state.userGroupId == 0 : false}
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Dialog>
        <Dialog
          style={{ width: '384px' }}
          type="normal"
          className="spaui-dialog-confirm-normal"
          title="确认是否修改团队"
          show={this.state.showTeamChangeDialog}
          onClose={this.handleEmployeeTeamChangeClose.bind(this)}
          onSubmit={this.handleTeamChangeConfirm.bind(this)}
          onCancel={this.handleEmployeeTeamChangeClose.bind(this)}
        >
          <div>
            <p align={'left'}>本次添加的员工将自动从原团队移除，删除的员工将自动移至默认团队。员工所分配的线索将随员工转移至新团队，若需将线索归属原团队，可先将线索分配给团队其他员工。是否确认变更？</p>
          </div>
        </Dialog>
      </div>
    );
  }
}

GroupDetailPresentationalComponent.propTypes = {
  userId: PropTypes.number,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
